/* eslint-disable no-console */

import { register } from 'register-service-worker'
const version = "1.4.0";
if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(version);
    },
    registered () {
     
    },
    cached () {
     
    },
    updatefound () {
     
    },
    updated () {
      window.location.reload(true)
    },
    offline () {
     
    },
    error () {
      
    }
  })
}
